import React, { useState } from "react";
import { Container, Card, Button } from "react-bootstrap";
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';


import Countdown, { zeroPad } from 'react-countdown';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import AOSService from "../../services/AOSServices";
import { useUserSettings } from '../UserSettingsProvider';
import queryString from "query-string"

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle, faSquare, faTrashAlt, faSpinner, faCheckCircle, faDumbbell, faDollarSign } from '@fortawesome/free-solid-svg-icons'
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons'

import "./Invite.css";
// import logo from '../../assets/site_logo.png';
import banner from '../../assets/MGM20230913.jpg';
import banner2 from '../../assets/MGM2023091302.jpg';
import since from '../../assets/since1999_tc.png';
import styled from "styled-components";
import { Helmet } from "react-helmet";


const DisclaimerPanel = styled.div`
    text-align: left;
    font-size: xx-small;
`;

const RegisterBox = styled.div`
    background-color: #efc5c5;
    border-radius: 30px;
`;

const ChallengeButton = styled(Button)`
    color: #c31313;
    border: 3px solid #a98b36;
    background-color: #ffdbb7;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: xx-large;
    font-weight: bolder;
    border-radius: 40px;

    --bs-btn-hover-bg: #fa0d3d;
    --bs-btn-hover-border-color: #c05d71;
    --bs-btn-focus-shadow-rgb: 13,110,253;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #fd0d3e;
    --bs-btn-active-border-color: #c15d71;
    --bs-btn-active-shadow: inset 0 6px 10px rgba(0, 0, 0, 0.125);
`;

const B1 = styled.div`
color: rgb(40, 63, 123);
display: inline;
font-family: inherit;
font-size: 1rem;
font-weight: bold;
line-height: 1.5;
margin: 0px;
text-align: left;
vertical-align: baseline;
text-decoration: none;
user-select: none;
`;

const B1H = styled.span`
    font-size: 1.5rem;
    color: rgb(204, 0, 16);
    padding: 0px 3px;
    font-weight: 1000;
`;

const B1D = styled.span`
color: gray;
display: inline;
font-family: inherit;
font-weight: 400;
line-height: 1.43;
margin: 0px;
text-align: left;
vertical-align: baseline;
text-decoration: none;
user-select: none;
`;

const IconPanel = styled.div`
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    justify-content: space-between;
    gap: 25px;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    width: 100%;
`;

const IconButtonLink = styled.a`
    :link { text-decoration: none; }
    :visited { text-decoration: none; }
    :hover { text-decoration: none; }
    :active { text-decoration: none; }
`;

const IconButton = styled.div`
    flex: 0 0 auto;
    cursor: pointer;
    border-radius: 4px;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 0px 4px;
    flex: 1 1 0%;
    padding: 5px;
    display: flex;
    flex-direction: column;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;

    svg {
            fill: rgb(204, 0, 16);
    }
`;

const IconButtonText = styled.span`
    color: rgb(204, 0, 16);
    display: inline;
    font-family: inherit;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.66;
    margin: 0px;
    text-align: center;
    vertical-align: baseline;
    text-decoration: none;
    user-select: none;
`;

const Icon = styled.div`
    text-align: center;
    vertical-align: middle;
    display: flex;
    flex-direction: column;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    position: relative;

    width: 30px;
    height: 30px;
    min-width: 30px;
    min-height: 30px;
`;

const BonusTitle = styled.div`
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    width: 100%;
    svg {
        fill: rgb(255, 222, 92);
        margin: 0px 10px;
        width: 20px;
        height: 20px;
    }
`;

const Invite = (props) => {
    library.add(faCircle, faSquare, faTrashAlt, faSpinner, faCheckCircle, faTimesCircle, faDumbbell, faDollarSign);

    const validationSchema = Yup.object().shape({
        CountryCode: Yup.string().required(),
        Mobile: Yup.string().required("請輸入你的手機號碼"),
        OTP: Yup.string()//.required("請輸入你的驗證碼"),
    }).required();

    const { register, watch, formState: { errors } } = useForm({
        mode: "all",
        resolver: yupResolver(validationSchema),
        defaultValues: {
            "CountryCode": "852",
            //"Mobile": "99999999",
            //"OTP": "123456"
        }
    });


    const watchAllFields = watch();


    const [isWaitingOTP, setIsWaitingOTP] = useState(false);
    const [isChallenge, setIsChallenge] = useState(false);
    const [errorMsg, setErrorMsg] = useState();
    const [OTPModel, setOTPModel] = useState({ Timer: 180, Prefix: "" });
    const [OTPInterval, setOTPInterval] = useState(Date.now() + (1000 * OTPModel.Timer));
    const { WizardInstance, referralCode } = props;
    const { setUserRef } = useUserSettings();


    const refOTPCountdown = React.createRef();

    const getOTP = () => {
        if (watchAllFields.CountryCode && watchAllFields.Mobile) {
            setErrorMsg("");
            setOTPModel({ Prefix: "", ...OTPModel });
            setIsWaitingOTP(true);

            //refTbxOTP.current.disabled = false;
            const countDownRef = refOTPCountdown.current;

            AOSService.ReqOTP(watchAllFields.CountryCode, watchAllFields.Mobile)
                .then(res => {
                    if (res) {
                        const { Prefix, Timer, Result } = res;
                        if (Result === 1) {
                            setOTPModel({ Prefix, Timer });
                            setOTPInterval(Date.now() + (1000 * OTPModel.Timer));
                            countDownRef.start();
                        } else if (Result === -1) {
                            setErrorMsg("你所提供的手機號碼已經登記開戶。");
                            setIsWaitingOTP(false);
                        } else if (Result === -3) {
                            setErrorMsg("内地居民身份证开户：客户须身处香港境内或海外地区");
                            setIsWaitingOTP(false);
                        }
                    }
                });
        }
    };

    const readyToGetOTP = () => (!isWaitingOTP && watchAllFields.Mobile?.length > 5);
    const isValid = () => (watchAllFields.Mobile?.length > 5 && watchAllFields?.OTP.length === 6);

    const countdownLayout = ({ hours, minutes, seconds, completed }) => {
        return (
            <span>獲取驗證碼
                {(completed) ? null : isWaitingOTP ? (<>({zeroPad(minutes)}:{zeroPad(seconds)})</>) : null}
            </span>);
    };

    const countdownCompleted = () => {
        setIsWaitingOTP(false);
    };

    const goChallenge = () => {
        setIsChallenge(true);
    };

    const validateOTP = (nextStep = null) => {
        const data = watchAllFields;

        //console.log('ae:'+referrerCode);
        //console.log(userRef, "pre");
        //ApiService.post("/home/validateotp", JSON.stringify(data))
        AOSService.ValidateOTP(data.CountryCode, data.Mobile, data.OTP, "", "", referralCode)
            .then(res => {
                if (res && res.Result) {
                    //console.log(res, "res");
                    if (WizardInstance.goToStep) {
                        setUserRef(res.UserRef);
                        //console.log(userRef, "dump");

                        const step = nextStep || res.UserRef.InitialStep || "IDType";
                        WizardInstance.goToNamedStep(step);
                    } else {
                        alert("login error!!");
                    }
                } else {
                    setErrorMsg("短訊驗證碼不正確");
                }
            });
    };
    
    const submitForm = () => validateOTP();
    const submitOpeningBooking = () => validateOTP("OpeningBooking");

    return (<>

        <Helmet>
            <meta charSet="utf-8" />
            <title>富昌一站通網上開戶 - 推薦好友 重重有賞</title>
            <meta name="description" content="【分享有禮】每介紹一位親友成功註冊並完成缐上見證即可獲HK$1,000「富昌電子佣金券」，名額有限，先到先得！" />

            <meta property="og:url" content="https://acc.ffg.com.hk" />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="推薦好友 重重有賞" />
            <meta property="og:description" content="【分享有禮】每介紹一位親友成功註冊並完成缐上見證即可獲HK$1,000「富昌電子佣金券」，名額有限，先到先得！" />
            <meta property="og:image" content="https://acc.ffg.com.hk/assets/app-referral.jpg" />


            <meta name="twitter:card" content="summary_large_image" />
            <meta property="twitter:domain" content="acc.ffg.com.hk" />
            <meta property="twitter:url" content="https://acc.ffg.com.hk" />
            <meta name="twitter:title" content="推薦好友 重重有賞" />
            <meta name="twitter:description" content="【分享有禮】每介紹一位親友成功註冊並完成缐上見證即可獲HK$1,000「富昌電子佣金券」，名額有限，先到先得！" />
            <meta name="twitter:image" content="https://acc.ffg.com.hk/assets/app-referral.jpg" />

        </Helmet>

        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <Row padding={0} className="MGM-bg" style={{ fontFamily: "Noto Sans HK,Noto Sans SC,sans-serif" }}>
            <Col lg={{ span: 6, offset: 3 }} xs={12}>
                <div className="py-lg-6 px-lg-4 py-3 px-2">
                    <img className="rounded-lg-5 rounded-4 img-fluid" src={banner} alt="" />
                </div>
            </Col>

            <Col lg={{ span: 6, offset: 3 }} xs={12}>
                <div className="py-lg-6 px-lg-4 py-3 px-2">
                    <img className="rounded-lg-5 rounded-4 img-fluid" src={banner2} alt="" />
                </div>
            </Col>

            <Col lg={{ span: 6, offset: 3 }} xs={12}>
            {!isChallenge && (
                        <div className="d-grid gap-2" style={{ padding: "30px 0px" }}>
                            <ChallengeButton
                                variant="outline-primary"
                                size="lg"
                                onClick={() => goChallenge()}>

                                <FontAwesomeIcon icon="fa-solid fa-dollar-sign" bounce />
                                <span> 接受邀請 </span>
                            </ChallengeButton>
                        </div>
                    )}
            </Col>

            {isChallenge && (
                <Col lg={{ span: 6, offset: 3 }} md={12} className="py-lg-6 px-lg-4 py-3 px-2">
                    <form className="my-0 p-0">
                        <RegisterBox className="p-3">
                            <div className="text-center mb-4">

                            </div>

                            <div className="px-4 my-2">
                                <select
                                    {...register("CountryCode")}
                                    className={`form-select form-select-lg mb-3`}
                                    disabled={isWaitingOTP}
                                >
                                    <option value="852"> 中國香港 </option>
                                    <option value="86"> 中國內地 </option>
                                    <option value="853"> 中國澳門 </option>
                                    <option value="886"> 中國台灣 </option>
                                </select>
                            </div>

                            <div className="px-4 my-2">
                                <div className={`input-group input-group-lg mb-3`}>
                                    <span className="input-group-text d-block text-center border-0 col-3"
                                        style={{ backgroundColor: "#fff" }}> + {watchAllFields.CountryCode} </span>
                                    <input
                                        {...register("Mobile")}
                                        disabled={isWaitingOTP}
                                        className={`form-control form-control-lg px-2 ${errors.Mobile ? 'is-invalid' : "border-0"}`}
                                        aria-label="手機號碼"
                                        placeholder="請輸入你的手機號碼" />
                                    {errors.Mobile &&
                                        <div className="invalid-feedback">
                                            {errors.Mobile.message}
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className="px-4 my-2">
                                <div className={`input-group input-group-lg mb-3`}>
                                    <span className="input-group-text d-block text-center text-danger border-0 col-3"
                                        style={{ backgroundColor: "#fff" }}> {OTPModel.Prefix} </span>
                                    <input type="text"
                                        {...register("OTP")}
                                        maxLength={6}
                                        //ref={refTbxOTP}
                                        //disabled={true}
                                        className={`form-control form-control-lg px-2 ${errors.OTP ? 'is-invalid' : "border-0"}`}
                                        placeholder="請輸入短訊驗證碼" />
                                    {errors.OTP &&
                                        <div className="invalid-feedback">
                                            {errors.OTP.message}
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className="px-4 my-2 d-grid gap-2 d-md-flex justify-content-md-end">
                                <button type="button"
                                    className="btn btn-block btn-warning"
                                    disabled={!readyToGetOTP()}
                                    onClick={() => getOTP()}
                                >
                                    <Countdown
                                        ref={refOTPCountdown}
                                        date={OTPInterval}
                                        renderer={countdownLayout}
                                        precision={2}
                                        autoStart={false} onComplete={countdownCompleted} />
                                </button>
                            </div>

                            <div className="row px-2">
                                <div className="px-4 d-grid gap-2 col-sm-12 col-md-6 mx-auto my-2">
                                    <button type="button"
                                        disabled={!isValid()}
                                        className="btn btn-block btn-danger"
                                        onClick={submitOpeningBooking}
                                    >
                                        預約開戶
                                    </button>
                                </div>

                                <div className="px-4 d-grid gap-2 col-sm-12 col-md-6 mx-auto my-2">
                                    <button type="button"
                                        disabled={!isValid()}
                                        className="btn btn-block btn-danger"
                                        onClick={submitForm}
                                    >
                                        確定
                                    </button>
                                </div>
                            </div>

                            {errorMsg && (<div className="px-4 d-grid gap-2 col-12 mx-auto my-2 alert alert-warning" role="alert">{errorMsg}</div>)}
                        </RegisterBox>
                    </form>
                </Col>
            )}

            <Col lg={{ span: 6, offset: 3 }} xs={12}>
                <div className=" py-lg-6 px-lg-4 py-3 px-2">
                    <Card className="rounded-4">
                        <br/>
                        <BonusTitle style={{ padding: '10px' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z"></path></svg>
                            <h4>
                                活動獎勵
                            </h4>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m19 9 1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z"></path></svg>
                        </BonusTitle>

                        <Card.Body>
                            <Tab.Container defaultActiveKey="applicant">
                                {/* <Row padding={0}>
                                    <Col Item lg={12}>
                                        <Nav fill variant="pills">
                                            <Nav.Item className="m-1">
                                                <Nav.Link bsPrefix='ffg-nav-link' eventKey="referee">介紹人</Nav.Link>
                                            </Nav.Item> 
                                            <Nav.Item className="m-1">
                                                <Nav.Link bsPrefix='ffg-nav-link' eventKey="applicant">親友</Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                    </Col>
                                </Row>*/}
                                <Row>
                                    <Col  lg={12}>
                                        <Tab.Content className="p-3">
                                            <a name="detail"></a>
                                            {/* <Tab.Pane eventKey="referee" style={{ textAlign: "left" }}>
                                                <h4>
                                                    親友成功註冊並完成缐上見證即可獲
                                                </h4>
                                                <p>
                                                    <svg width="50" height="26" fill="#ffd96e" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                        <path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"></path>
                                                    </svg>

                                                    <B1><B1H>HK$1,000</B1H>「富昌電子佣金券」</B1>
                                                </p>

                                            </Tab.Pane> */}
                                            <Tab.Pane eventKey="applicant" style={{ textAlign: "left" }}>
                                                <h4>
                                                    成功線上見證後可獲以下限時豐富獎賞
                                                </h4>

                                                <p>
                                                    <svg width="50" height="26" fill="#ffd96e" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                        <path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"></path>
                                                    </svg>

                                                    <B1>港期/期權 <B1H>0</B1H> 佣</B1>
                                                </p>


                                                <p>
                                                    <svg width="50" height="26" fill="#ffd96e" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                        <path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"></path>
                                                    </svg>

                                                    <B1> 港股 <B1H>0</B1H> 佣金 </B1>
                                                </p>

                                                <p>
                                                    <svg width="50" height="26" fill="#ffd96e" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                        <path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"></path>
                                                    </svg>

                                                    <B1> <B1H>免費</B1H> 港美股串流報價 </B1>
                                                </p>

                                                <p>
                                                    <svg width="50" height="26" fill="#ffd96e" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                        <path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"></path>
                                                    </svg>

                                                    <B1>送<B1H>10萬</B1H>積分 <B1D>(積分可兌換獎金)</B1D></B1>
                                                </p>

                                                <p>
                                                    <svg width="50" height="26" fill="#ffd96e" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                        <path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"></path>
                                                    </svg>

                                                    <B1>轉倉送高達<B1H>HK$10,000</B1H>佣金券</B1>
                                                </p>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Col>
                                </Row>
                            </Tab.Container>


                            <Row>
                                <Col xs={6} md={4}>
                                    <IconButtonLink href="#detail">
                                        <IconButton>
                                            <Icon>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"></path></svg>
                                            </Icon>
                                            <IconButtonText>推薦計劃詳情</IconButtonText>
                                        </IconButton>
                                    </IconButtonLink>
                                    <br></br>
                                </Col>

                                <Col  xs={6} md={4}>
                                    <IconButtonLink target="_blank" href="https://www.ffg.com.hk/promotions/future100free">
                                        <IconButton>
                                            <Icon>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g id="Group_906" data-name="Group 906" transform="translate(0 0)"><circle id="Ellipse_15" data-name="Ellipse 15" cx="0.4" cy="0.4" r="0.4" transform="translate(12.4 12)"></circle><circle id="Ellipse_16" data-name="Ellipse 16" cx="0.4" cy="0.4" r="0.4" transform="translate(14 12)"></circle><circle id="Ellipse_17" data-name="Ellipse 17" cx="0.4" cy="0.4" r="0.4" transform="translate(15.6 12)"></circle><path id="Path_515" data-name="Path 515" d="M13.1,14.8a.4.4,0,0,0-.4-.4H10.3a.4.4,0,0,0,0,.8h2.4A.4.4,0,0,0,13.1,14.8Z" transform="translate(-1.9 -2.4)"></path><circle id="Ellipse_18" data-name="Ellipse 18" cx="0.4" cy="0.4" r="0.4" transform="translate(12.4 8.8)"></circle><circle id="Ellipse_19" data-name="Ellipse 19" cx="0.4" cy="0.4" r="0.4" transform="translate(14 8.8)"></circle><circle id="Ellipse_20" data-name="Ellipse 20" cx="0.4" cy="0.4" r="0.4" transform="translate(15.6 8.8)"></circle><path id="Path_516" data-name="Path 516" d="M12.7,10.8H10.3a.4.4,0,0,0,0,.8h2.4a.4.4,0,1,0,0-.8Z" transform="translate(-1.9 -2)"></path><circle id="Ellipse_21" data-name="Ellipse 21" cx="0.4" cy="0.4" r="0.4" transform="translate(12.4 5.6)"></circle><circle id="Ellipse_22" data-name="Ellipse 22" cx="0.4" cy="0.4" r="0.4" transform="translate(14 5.6)"></circle><circle id="Ellipse_23" data-name="Ellipse 23" cx="0.4" cy="0.4" r="0.4" transform="translate(15.6 5.6)"></circle><path id="Path_517" data-name="Path 517" d="M10.3,7.2a.4.4,0,0,0,0,.8h2.4a.4.4,0,1,0,0-.8Z" transform="translate(-1.9 -1.6)"></path><path id="Path_518" data-name="Path 518" d="M16.411,20.348a.4.4,0,1,0-.566.566l.643.642-2.263,2.263-1.062-1.063a.4.4,0,0,0-.47-.07,6.353,6.353,0,0,1-1.11.462.4.4,0,0,0-.282.382v1.5H8.1v-1.5a.4.4,0,0,0-.282-.382,6.353,6.353,0,0,1-1.11-.462.4.4,0,0,0-.47.07L5.175,23.819,2.912,21.556l1.063-1.062a.4.4,0,0,0,.07-.47,6.39,6.39,0,0,1-.462-1.11.4.4,0,0,0-.382-.282H1.7v-3.2H3.2a.4.4,0,0,0,.382-.282,6.39,6.39,0,0,1,.462-1.11.4.4,0,0,0-.07-.47L2.912,12.506l2.263-2.263.642.643a.4.4,0,1,0,.566-.566l-.925-.926a.4.4,0,0,0-.566,0L2.063,12.222a.4.4,0,0,0,0,.566L3.2,13.929a7.176,7.176,0,0,0-.293.7H1.3a.4.4,0,0,0-.4.4v4a.4.4,0,0,0,.4.4H2.911a7.177,7.177,0,0,0,.293.7l-1.141,1.14a.4.4,0,0,0,0,.566l2.828,2.828a.4.4,0,0,0,.566,0L6.6,23.527a7.193,7.193,0,0,0,.7.293v1.611a.4.4,0,0,0,.4.4h4a.4.4,0,0,0,.4-.4V23.82a7.193,7.193,0,0,0,.7-.293l1.14,1.141a.4.4,0,0,0,.566,0l2.828-2.828a.4.4,0,0,0,0-.566Z" transform="translate(-0.9 -1.831)"></path><path id="Path_519" data-name="Path 519" d="M6.683,18a.4.4,0,0,0-.36.438A4.383,4.383,0,0,0,12.6,21.96a.4.4,0,1,0-.347-.72,3.55,3.55,0,0,1-1.55.36,3.586,3.586,0,0,1-3.582-3.24A.4.4,0,0,0,6.683,18Z" transform="translate(-1.502 -2.8)"></path><path id="Path_520" data-name="Path 520" d="M25.3,4.9H24.2c-.022-.056-.045-.111-.07-.166l.78-.779a.4.4,0,0,0,0-.566l-1.7-1.7a.4.4,0,0,0-.566,0l-.779.78c-.056-.024-.111-.048-.166-.07V1.3a.4.4,0,0,0-.4-.4H18.9a.4.4,0,0,0-.4.4V2.4c-.056.022-.111.046-.166.07l-.779-.78a.4.4,0,0,0-.566,0l-1.7,1.7a.4.4,0,1,0,.566.566L17.272,2.54l.7.7a.4.4,0,0,0,.468.072,3.581,3.581,0,0,1,.584-.244.4.4,0,0,0,.28-.382V1.7h1.6v.984a.4.4,0,0,0,.28.382,3.581,3.581,0,0,1,.584.244.4.4,0,0,0,.468-.072l.7-.7L24.06,3.672l-.7.7a.4.4,0,0,0-.072.468,3.631,3.631,0,0,1,.244.583.4.4,0,0,0,.382.28H24.9V7.3h-.984a.4.4,0,0,0-.382.28,3.631,3.631,0,0,1-.244.583.4.4,0,0,0,.072.468l.7.7L22.928,10.46l-.7-.7a.4.4,0,0,0-.468-.072,3.581,3.581,0,0,1-.584.244.4.4,0,0,0-.28.382V11.7a.4.4,0,1,0,.8,0V10.6c.056-.022.111-.046.166-.07l.779.78a.4.4,0,0,0,.566,0l.089-.088v4.954a1.2,1.2,0,0,0-.726.726H18.5v-.4a.4.4,0,0,0-.4-.4H15.3v-.8h4.4a.4.4,0,0,0,.4-.4V5.3a.4.4,0,0,0-.4-.4H16.9a.4.4,0,0,0,0,.8h2.4V8.1H8.9V5.7h6.4a.4.4,0,1,0,0-.8H8.5a.4.4,0,0,0-.4.4v9.6a.4.4,0,0,0,.4.4h1.6a.4.4,0,0,0,0-.8H8.9V12.1H19.3v2.4H11.7a.4.4,0,0,0,0,.8h1.2v.8H10.5a.4.4,0,0,0-.4.4v.4H8.9a.4.4,0,0,0,0,.8h1.2v.4a.4.4,0,0,0,.4.4h7.6a.4.4,0,0,0,.4-.4v-.4h4.074A1.2,1.2,0,1,0,24.1,16.174V10.42l.808-.808a.4.4,0,0,0,0-.566l-.78-.779c.025-.056.048-.111.07-.166h1.1a.4.4,0,0,0,.4-.4V5.3A.4.4,0,0,0,25.3,4.9ZM8.9,11.3V8.9H19.3v2.4Zm8.8,6.4H10.9v-.8h2.4a.4.4,0,0,0,.4-.4V15.3h.8v1.2a.4.4,0,0,0,.4.4h2.8Zm6,0a.4.4,0,1,1,.4-.4A.4.4,0,0,1,23.7,17.7Z" transform="translate(-1.7 -0.9)"></path><path id="Path_521" data-name="Path 521" d="M22.657,8.223a.4.4,0,1,0,.48.638,2.382,2.382,0,0,0,0-3.82.4.4,0,0,0-.482.64,1.582,1.582,0,0,1,0,2.544Z" transform="translate(-3.297 -1.351)"></path></g></svg>
                                            </Icon>
                                            <IconButtonText>港期/期權0佣優惠</IconButtonText>
                                        </IconButton>
                                    </IconButtonLink>
                                    <br></br>
                                </Col>

                                <Col  xs={6} md={4}>
                                    <IconButtonLink target="_blank" href="https://www.ffg.com.hk/promotions/0commission">
                                        <IconButton>
                                            <Icon>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"></path></svg>
                                            </Icon>
                                            <IconButtonText>港股0佣金</IconButtonText>
                                        </IconButton>
                                    </IconButtonLink>
                                    <br></br>
                                </Col>

                                <Col  xs={6} md={4}>
                                    <IconButtonLink target="_blank" href="https://www.ffg.com.hk/promotions/free_quote">
                                        <IconButton>
                                            <Icon>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g id="Group_908" data-name="Group 908" transform="translate(10.969 6.161)"><g id="Group_907" data-name="Group 907"><path id="Path_524" data-name="Path 524" d="M21.79,15.982v-8.6a.459.459,0,0,0-.486-.452H19.425a.472.472,0,0,0-.5.452v7.759a4.532,4.532,0,0,0-.923.121V9.918a.475.475,0,0,0-.5-.461H15.629a.468.468,0,0,0-.49.461v7.249a4.766,4.766,0,0,0-.884,2.787,4.814,4.814,0,1,0,7.536-3.972ZM19.9,7.9h.923v7.565a4.327,4.327,0,0,0-.923-.252Zm-3.787,2.525h.923V15.6a4.944,4.944,0,0,0-.923.554ZM22.377,21.91A3.841,3.841,0,1,1,17.6,16.4a.461.461,0,0,0,.16-.063,3.768,3.768,0,0,1,1.311-.233c.1,0,.2,0,.3.015h0a3.751,3.751,0,0,1,1.651.524A3.84,3.84,0,0,1,22.377,21.91Z" transform="translate(-14.254 -6.932)"></path></g></g><g id="Group_910" data-name="Group 910" transform="translate(14.213 15.809)"><g id="Group_909" data-name="Group 909"><path id="Path_525" data-name="Path 525" d="M19.481,20.766a.614.614,0,1,1,.607-.617.487.487,0,0,0,.486.486.492.492,0,0,0,.5-.486,1.586,1.586,0,0,0-1.005-1.476v-.4a.486.486,0,0,0-.971,0v.35a1.584,1.584,0,0,0-1.136,1.928,1.563,1.563,0,0,0,1.52,1.185.609.609,0,1,1-.612.607.487.487,0,0,0-.486-.486.472.472,0,0,0-.476.481v0a1.59,1.59,0,0,0,1.185,1.529v.218a.486.486,0,1,0,.971,0V23.82a1.581,1.581,0,0,0-.578-3.054Z" transform="translate(-17.903 -17.785)"></path></g></g><g id="Group_912" data-name="Group 912" transform="translate(4.23 12.571)"><g id="Group_911" data-name="Group 911"><path id="Path_526" data-name="Path 526" d="M9.052,14.142H7.158a.487.487,0,0,0-.486.486V22.25a.487.487,0,0,0,.486.486H9.052a.487.487,0,0,0,.486-.486V14.627A.487.487,0,0,0,9.052,14.142Zm-.486,7.671H7.644v-6.7h.923Z" transform="translate(-6.673 -14.142)"></path></g></g><g id="Group_914" data-name="Group 914" transform="translate(8.066 11.454)"><g id="Group_913" data-name="Group 913"><path id="Path_527" data-name="Path 527" d="M13.367,12.885H11.474a.487.487,0,0,0-.486.486v8.788a.487.487,0,0,0,.486.486h1.894a.487.487,0,0,0,.486-.486V13.371A.487.487,0,0,0,13.367,12.885Zm-.486,8.788h-.923V13.857h.923Z" transform="translate(-10.988 -12.885)"></path></g></g><g id="Group_916" data-name="Group 916" transform="translate(0.394 16.746)"><g id="Group_915" data-name="Group 915"><path id="Path_528" data-name="Path 528" d="M4.737,18.839H2.843a.487.487,0,0,0-.486.486v3.447a.487.487,0,0,0,.486.486H4.737a.487.487,0,0,0,.486-.486V19.325A.487.487,0,0,0,4.737,18.839Zm-.486,3.5H3.329V19.81h.923Z" transform="translate(-2.358 -18.839)"></path></g></g><g id="Group_918" data-name="Group 918" transform="translate(0)"><g id="Group_917" data-name="Group 917"><path id="Path_529" data-name="Path 529" d="M20.346,0,17.025,0a.486.486,0,1,0-.01.971h.01l2.151,0L13.908,6.22l-1.84-1.826a.534.534,0,0,0-.689,0L2.056,13.716a.484.484,0,0,0,.689.68l8.982-8.982,1.84,1.855a.486.486,0,0,0,.345.155.516.516,0,0,0,.345-.155l5.6-5.608,0,2.161a.486.486,0,1,0,.971,0l0-3.331A.491.491,0,0,0,20.346,0Z" transform="translate(-1.914)"></path></g></g></svg>
                                            </Icon>
                                            <IconButtonText>免費串流報價</IconButtonText>
                                        </IconButton>
                                    </IconButtonLink>
                                    <br></br>
                                </Col>

                                <Col  xs={6} md={4}>
                                    <IconButtonLink target="_blank" href="https://www.ffg.com.hk/promotions/bonus_point">
                                        <IconButton>
                                            <Icon>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path id="Path_530" data-name="Path 530" d="M21.588,10.661c-6.382-3.245-13.634,2.712-10.318,8.178,1.539,2.567,5.094,4.189,9.3,2.972.841.327,1.59.856,2.406,1.25-.211-.709-.436-1.411-.675-2.109,4.346-3.1,3.395-8.2-.712-10.291Zm-5.094,3.684a.986.986,0,1,1-1.259-1.276.992.992,0,0,1,1.259,1.276Zm4.775.094h.014a1,1,0,0,1-1.573.27,1.506,1.506,0,0,1-.344-.732,1.108,1.108,0,0,1,.929-.958,1,1,0,0,1,.974,1.421Z" transform="translate(-1.144 -3.055)"></path><path id="Path_531" data-name="Path 531" d="M17.394,8.486a7.587,7.587,0,0,0-3.82-4.995H13.6C6.908-.292-1.425,4.984.185,11.205a7.549,7.549,0,0,0,3.259,4.427c-.3.852-.584,1.7-.854,2.562.974-.511,1.948-1.046,2.923-1.565a10.8,10.8,0,0,0,3.656.519c-1.536-4.408,2.4-9.077,8.226-8.662ZM11.324,5.928a1.229,1.229,0,0,1,1.649,1.189l0,.012a1.228,1.228,0,1,1-1.651-1.2Zm-4.4,1.446a1.232,1.232,0,0,1-1.944.679,1.23,1.23,0,1,1,1.944-.679Z" transform="translate(0.017 -2.219)"></path></g></svg>
                                            </Icon>
                                            <IconButtonText>送10萬積分</IconButtonText>
                                        </IconButton>
                                    </IconButtonLink>
                                    <br></br>
                                </Col>

                                <Col  xs={6} md={4}>
                                    <IconButtonLink target="_blank" href="https://www.ffg.com.hk/promotions/transfer_free">
                                        <IconButton>
                                            <Icon>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path id="software_1_" data-name="software (1)" d="M10.132,6.366a.352.352,0,0,0,.352-.352V5.607a.352.352,0,1,0-.7,0v.408A.352.352,0,0,0,10.132,6.366Zm-4.914,0a.352.352,0,0,0,.352-.352V5.607a.352.352,0,0,0-.7,0v.408A.352.352,0,0,0,5.218,6.366ZM4.667,8.905h6.016a.352.352,0,1,0,0-.7H4.667a.352.352,0,1,0,0,.7ZM7.675,6.68a1.211,1.211,0,0,0,.913-.416.352.352,0,1,0-.53-.462.507.507,0,0,1-.765,0,.352.352,0,0,0-.53.462,1.21,1.21,0,0,0,.913.416ZM4.667,10.816h6.016a.352.352,0,0,0,0-.7H4.667a.352.352,0,0,0,0,.7Zm16.2-9.381h-.5a.352.352,0,1,0,0,.7h.5A2.43,2.43,0,0,1,23.3,4.565v9.47H22.1V4.916a1.582,1.582,0,0,0-1.58-1.58H3.481A1.582,1.582,0,0,0,1.9,4.916v9.12H.7V4.565A2.43,2.43,0,0,1,3.13,2.138H18.71a.352.352,0,0,0,0-.7H3.13A3.134,3.134,0,0,0,0,4.565v10.6a3.124,3.124,0,0,0,2.583,3.082.352.352,0,1,0,.122-.692,2.422,2.422,0,0,1-2-2.39v-.426H23.3v.426a2.43,2.43,0,0,1-2.427,2.427H4.295a.352.352,0,0,0,0,.7H8.5l-.188,2.036H8.159A1.512,1.512,0,0,0,6.717,21.41l-.081.276a.934.934,0,0,0,.9,1.2h8.936a.934.934,0,0,0,.9-1.2l-.081-.276a1.512,1.512,0,0,0-1.442-1.079h-.153L15.5,18.295H20.87A3.134,3.134,0,0,0,24,15.164V4.565a3.134,3.134,0,0,0-3.13-3.13Zm-8.3,12.6H2.6V4.916a.878.878,0,0,1,.877-.877h9.087Zm8.829,0H13.271v-10h7.249a.878.878,0,0,1,.877.877v9.12ZM9.206,18.295h5.589l.188,2.036H9.018Zm6.635,2.739a.8.8,0,0,1,.768.574l.081.276a.231.231,0,0,1-.222.3H7.532a.227.227,0,0,1-.185-.093.229.229,0,0,1-.037-.2l.081-.276a.8.8,0,0,1,.768-.574h7.682Zm-3.166-4.869A.674.674,0,1,0,12,16.84.674.674,0,0,0,12.674,16.165Zm7.681-9.411L17.963,5.373a1.263,1.263,0,0,0-1.259,0L14.312,6.754a.588.588,0,0,0-.3.474.351.351,0,0,0,0,.042v3.287a.59.59,0,0,0,.3.516L16.7,12.454a1.258,1.258,0,0,0,.6.167l.03,0,.03,0a1.258,1.258,0,0,0,.6-.167l2.392-1.381a.59.59,0,0,0,.3-.516V7.27a.351.351,0,0,0,0-.042A.588.588,0,0,0,20.355,6.754ZM16.982,11.8,14.717,10.5V8.02L16.7,9.167a1.253,1.253,0,0,0,.278.118Zm.073-3.245L14.824,7.27l2.231-1.288a.558.558,0,0,1,.556,0L19.843,7.27,17.612,8.558A.558.558,0,0,1,17.056,8.558ZM19.95,10.5,17.685,11.8V9.285a1.251,1.251,0,0,0,.278-.118L19.95,8.02V10.5ZM4.667,12.727H8a1.084,1.084,0,0,0,2.05,0h.631a.352.352,0,0,0,0-.7h-.631a1.084,1.084,0,0,0-2.05,0H4.667a.352.352,0,0,0,0,.7Zm4.361-.732a.381.381,0,1,1-.381.381A.381.381,0,0,1,9.028,11.994Z" transform="translate(0 -1.435)"></path></svg>
                                            </Icon>
                                            <IconButtonText>轉倉優惠</IconButtonText>
                                        </IconButton>
                                    </IconButtonLink>
                                    <br></br>
                                </Col>

                            </Row>

                            
                            <Row className="justify-content-center">
                                <Col xs={{span: 6}} md={{ offset: 0, span: 3}}>
                                    <img className="rounded-2 img-fluid my-2" src={since} alt="" />
                                </Col>
                            </Row>

                            <Row>
                                <Col style={{ textAlign: "left" }}>

                                    <p>
                                        <B1H>極速體驗</B1H><br/>
                                        最快3分鐘完成開戶*，全程線上認證，即日可以買賣
                                    </p>

                                    <p>
                                        <B1H>產品豐富</B1H><br/>
                                        隨時隨地獲取市場報價及相關資訊進行交易，覆蓋港美A股三大市場，提供月供股票、特低孖展利息，主攻防守兼備，多種投資工具供您選擇，輕鬆應對各種市況！
                                    </p>

                                    <p>
                                        <B1H>實用工具</B1H><br/>
                                        設「雙報價」界面，一個畫頁同時顯示2隻心水股票即時報價及走勢 ，支援指數及股票圖表分析，行業版塊、沽空排行、牛熊街貨、財務解讀等大數據，一應俱全。
                                    </p>

                                    <p>
                                        <B1H>全面功能</B1H><br/>
                                        24小時查看戶口結餘及監控交易狀況，更具有金管局認可的 eDDA、轉數快 (FPS) 等提存方法、內部轉帳、兌換外幣等功能，方便至極 。
                                    </p>

                                    <p>
                                        <B1H>貼心服務</B1H><br/>
                                        提供多平台客服支援，及時解決您的問題，不斷改善服務，為您帶來最極致可靠體驗 。
                                    </p>

                                    <p>
                                        <B1H>屢獲殊榮 安全可靠</B1H><br/>
                                        聲譽良好，獲多項殊榮，包括由港交所頒發的「2021最大躍進衍生產品數據供應商」等， 持香港證監會1、2、4、5及9號牌照 (中央編號：AFB820及 AME963) 資產受到監管機構投資賠償基金嚴格保障，交易信息採用銀行級高度加密技術保護，確保客戶資產和資料安全 。
                                    </p>

                                    <p>
                                    *實際所需時間或會因個別情況而有所不同。
                                    </p>
                                </Col>
                            </Row>
                           

                        </Card.Body>
                    </Card>

                </div>
            </Col>

            <Col lg={12} md={12}>
 

            </Col>

            <Col lg={12} md={12} style={{ padding: 0, backgroundColor: "#ffffff" }}>

                <Col lg={{ span: 6, offset: 3 }}  xs={12}>
                    <DisclaimerPanel className="px-3 py-5">

                        條款及細則：<br />
                        <ol>
                            <li>
                                推廣期由2023年8月10日起，直至另行通知。
                            </li>
                            <li> 現有客戶 ( “介紹人” ) 透過一站通內推薦客戶頁面獲得推薦連結，並分享連結予其親友。透過介紹人的指定連結於「富亨通APP」註冊及成為尊貴客戶的任務，介紹人可獲 HK$1,000「富昌電子佣金券」，親友同時亦可享迎新禮遇。
                            </li>
                            <li> 每成功介紹一位親友並完成任務，可獲HK$1,000「富昌電子佣金券」(適用於證券或期貨戶口)，完成任務的親友愈多，獲得的「富昌電子佣金券」愈多，名額有限，先到先得。
                            </li>
                            <li> 如親友沒有透過介紹人的指定連結完成上述程序，介紹人亦可自行通知本公司客戶服務部並登記享有相關獎勵，唯必須在親友完成上述程序後的10個工作天內提出，同時需待本公司與該名親友核實後，方會被接納受理。
                            </li>
                            <li> 如同一親友收到多個介紹人的連結，本公司則按其使用之指定連結作為依據，並安排相關獎賞，一切以本公司系統記錄為準。
                            </li>
                            <li> 介紹人需持有本公司有效的證券或期貨賬戶，方可領取相關HK$1,000「富昌電子佣金券」獎賞。「富昌電子佣金券」會以電子方式存入介紹人所選的證券或期貨賬戶 (「該賬戶」) 內。此佣金券只可作抵銷交易佣金之用，不可兌現，有效期為3個月。
                            </li>
                            <li> 「富昌電子佣金券」兌換方法 : 佣金券生效後的第1個月月結後，於下一個月中旬，自動回贈第1個月的交易佣金額 (如有) 的一半到該賬戶，回贈上限為HK$1,000。如佣金券行使後尚有餘額，可轉入至第2個月使用，如此類推，直至第3個月到期為止。到期後未使用的佣金券餘額，則會失效作廢。
                            </li>
                            <li> 如介紹人屬於本公司的經紀客戶，請先行與相關經紀查詢有關詳情。
                            </li>
                            <li> 所有上述之優惠不可兌換成現金或其他貨品、服務及優惠。
                            </li>
                            <li> 本公司保留隨時更改本優惠條款及細則的權利。本行亦可能運用酌情權取消此優惠而毋須事先通知。
                            </li>
                            <li> 此推廣活動並非及不應被視為進行任何投資的邀請、要約或建議。客戶應注意，投資涉及風險，投資產品價格可升可跌，投資前請充分理解產品風險，並諮詢專業顧問。
                            </li>
                            <li> 介紹人必須明確保證其本人並無經營任何有關證券行業的推薦或介紹業務，因為這可能導致觸犯從事證券及期貨條例下所訂明的無牌進行受規管活動。
                            </li>
                            <li>
                                如有任何爭議，本公司保留最終決定權。
                            </li>
                            <li>
                                本廣告或/及網頁及活動細則並未經香港證券及期貨事務監察委員會或任何監管機構審核。
                            </li>
                        </ol>
                    </DisclaimerPanel>
                </Col>
            </Col>

            <Col lg={12} md={12} style={{ padding: 0, backgroundColor: "#e1e1e1" }}>
                <Col lg={{ span: 6, offset: 3 }}  xs={12}>
                    <br></br>
                </Col>
            </Col>
        </Row>




    </>);
};

export default Invite;